const { $, dict, rz } = window;

export default async function changeLanguage(curlng) {
  const data = { curlng };

  // detect Presentation page
  const isPresentation = Boolean(document.location.pathname.startsWith("/presentation"));

  // detect curTheme:
  const curtheme = $("html").attr("data-theme");

  rz.log({message: "Change LNG -> " + curlng, caller: "SSR.changeLanguage()"});

  const res = await fetch("/api/changelng", {method: "POST", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
  const ans = await res.json();
  if (!ans || !ans.result || !ans.curlng) return rz.log({message: "Cant change language on Server! Response:\n" + rz.errToString(ans), msgtype: "error", caller: "SSR.changeLanguage()"});

  dict.set(ans.curlng);

  // Call react-functions in miniapps
  if (window.changelngglobal) {
    window.changelngglobal.forEach((fn) => {
      try { fn(ans.curlng) }
      catch (err) { console.error(err) }
    });
  }

  // Change option active-state
  const lgt = (isPresentation && curtheme === "light" ? "rz-button-dark" : "rz-button-light");
  const drk = (isPresentation && curtheme === "light" ? "rz-button-light" : "rz-button-dark");
  $("#set-lng-" + curlng).addClass(["active", drk]).removeClass([lgt]);
  $("#set-lng-" + (curlng === "ru" ? "en" : "ru")).addClass([lgt]).removeClass([drk]);

  // Change head and meta tags
  $("html").attr("lang", ans.curlng);
  $("meta[name='description']").attr("content", dict[ans.curlng].p.prgtitle);
  document.title = dict[ans.curlng].p.prgtitle;

  // Change lng on elements
  $("[dict]").each((i, item) => {
    const d1 = $(item).attr("dict");
    if (d1) {
      const a1 = rz.objByString(dict[ans.curlng], d1);
      // debug-1
      // if (d1 === "other.geography") console.log({d1, a1}); // , dct: dict[ans.curlng]
      // debug-2
      // $(item).prop("tagName") === "BUTTON"
      // if ($(item).attr("dict") === "p.changetheme") { console.log({item, a1}) }

      $(item).html(a1);
    }
    // Additionaly we should change some tag properties
    const at = item.attributes;
    Object.keys(at).forEach((key) => {
      if (at[key] && at[key].nodeName) {
        const cattr = at[key].name || "", vattr = at[key].value || "";
        if (~cattr.indexOf("dict-")) {
          const mattr = cattr.substr(5);
          const b1 = rz.objByString(dict[ans.curlng], vattr);
          $(item).attr(mattr, b1);
        }
      }
    });
  });

  return ans.curlng;
}
